<template>
  <div class="table-responsive mt-2" ref="formContainer">
    <div
      class="row"
      style="
        margin-bottom: 1px;
        margin-left: 0px;
        justify-content: space-between;
      "
    >
      <div class="col-2 px-2">
        <div class="form-group">
          <label
            style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px"
            >Select Organization</label
          >
          <multiselect
            :options="organizations"
            :allow-empty="true"
            :searchable="true"
            :multiple="true"
            :selectedLabel="null"
            :deselectLabel="null"
            :selectLabel="null"
            :open-direction="'bottom'"
            @input="organizationSearch(org_search)"
            v-model="org_search"
            label="name"
            track-by="organization_id"
          >
          </multiselect>
        </div>
      </div>

      <div class="col-2 px-2">
        <label
          style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px"
          >Admin User</label
        >
        <multiselect
          @input="filterByAdminUser(selectedType)"
          :options="type_filter"
          :selectedLabel="null"
          :deselectLabel="null"
          :allow-empty="true"
          :selectLabel="null"
            :multiple="true"
          :searchable="true"
          v-model="selectedType"
          label="name"
          track-by="id"
          style="font-size: 12px !important"
        >
        </multiselect>
      </div>
      <div class="col-2 px-2">
        <label
          style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px"
          >Type</label
        >
        <multiselect
          @input="filterByLogType($event)"
         
          :options="type_logs"
          :selectedLabel="null"
          :deselectLabel="null"
          :allow-empty="true"
            :multiple="true"
          :selectLabel="null"
          :searchable="true"
          v-model="logType"
          label="name"
          track-by="log_type"
          style="font-size: 12px !important"
        >
        </multiselect>
      </div>
      <div class="col-2 px-2">
        <label
          style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px"
          >Action</label
        >
        <multiselect
          @input="filterByLogActionType($event)"
         
          :options="type_actions"
          :selectedLabel="null"
          :deselectLabel="null"
            :multiple="true"
          :allow-empty="true"
          :selectLabel="null"
          :searchable="true"
          v-model="actionType"
          label="name"
          track-by="log_action"
          style="font-size: 12px !important"
        >
        </multiselect>
      </div>

      <div class="col-2 px-2 has-search">
        <label
          style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px"
          >Search</label
        >
        <span class="fa fa-search form-control-feedback"></span>
        <input
          type="text"
          style="background-color: #ffffff"
          class="form-control"
          v-model="search"
          @keyup="usersBySearch"
          placeholder="Search User..."
        />
      </div>
      <div class="col-2 px-2">
        <label
          style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px"
          >Date Range</label
        >
        <multiselect
          :options="date_filters"
          :allow-empty="true"
          :searchable="true"
          :selectedLabel="null"
          :deselectLabel="null"
          :selectLabel="null"
          :open-direction="'bottom'"
          @input="applyDateFilter()"
          v-model="dateValue"
          label="name" :taggable="true"
          :close-on-select="true"
          track-by="date_val"
        >
        </multiselect>
      </div>
     
      
        <div v-if="dateValue.date_val === 'customDate' && showCustomInputs"
      class="row"
      style="
        margin-bottom: 1px;
        margin-left: 0px;
        justify-content: space-between;
            justify-content: right;
      "
    >
     
          <div class="col-2 px-2">
          <div class="form-group">
            <label style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px;">From</label>
            <input  @input="applyDateFilter()"
          type="date"
          v-model="customDate.from" class="form-control" placeholder="Select From Date" />
        </div>
        </div>
        <div class="col-2 px-2">
        <div class="form-group">
            <label style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px;">To</label>
            <input  @input="applyDateFilter()"
          type="date"
          v-model="customDate.to" class="form-control" placeholder="Select To Date" />
        </div>
      </div>
      </div>
      </div>
    <table
      class="table table-hover text-left"
      id="dataTable"
      width="100%"
      cellspacing="0"
    >
      <thead>
        <tr>
          <th style="width: 150px">Admin User</th>
          <th>Role</th>
          <th>Organization</th>
          <th>Organization User</th>
          <th>Description</th>
          <th>Activity Date</th>
          <th>Activity Type</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="isLoader" id="table_row">
          <td colspan="16">
            <b-skeleton-wrapper>
              <b-skeleton height="40px"></b-skeleton>
              <b-skeleton height="40px"></b-skeleton>
              <b-skeleton height="40px"></b-skeleton>
            </b-skeleton-wrapper>
          </td>
        </tr>
        <user-row
          v-show="!isLoader"
          v-for="user in filteredList"
          :user="user"
          :key="user.slug"
        ></user-row>
      </tbody>
    </table>

    <h5 style="text-align: center" v-if="filteredList.length < 1 && !isLoader">
      No data found.
    </h5>

    <paginate v-if="!isLoader" v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''"
      :first-button-text="''" :last-button-text="''" :first-last-button="true"
      :container-class="'pagination pagination-sm float-right mb-0 mt-3 mr-4'" :page-class="'page-item'"
      :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'"
      :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
  </div>
</template>

<script>
// import moment from 'moment';
import $ from "jquery";
import axios from "axios";
import UserRow from "./admin_logs_row";
import Multiselect from "vue-multiselect";
export default {
  components: {
    UserRow,
    Multiselect,
  },
  data: function () {
    return {
      date_filters: [
        { name: "All", date_val: "no_date" },
        {
          name: "Tomorrow",
          date_val: (() => {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            return `${tomorrow.toLocaleDateString()} to ${tomorrow.toLocaleDateString()}`;
          })(),
        },
        {
          name: "Yesterday",
          date_val: (() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return `${yesterday.toLocaleDateString()} to ${yesterday.toLocaleDateString()}`;
          })(),
        },
        {
          name: "This Week",
          date_val: (() => {
            const startOfWeek = new Date();
            startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
            const endOfWeek = new Date(startOfWeek);

            endOfWeek.setDate(startOfWeek.getDate() + 6);
            return `${startOfWeek.toLocaleDateString()} to ${endOfWeek.toLocaleDateString()}`;
          })(),
        },
        {
          name: "Last Week",
          date_val: (() => {
            const lastWeekStart = new Date();
            lastWeekStart.setDate(
              lastWeekStart.getDate() - lastWeekStart.getDay() - 7
            );
            const lastWeekEnd = new Date(lastWeekStart);
            lastWeekEnd.setDate(lastWeekStart.getDate() + 6);
            return `${lastWeekStart.toLocaleDateString()} to ${lastWeekEnd.toLocaleDateString()}`;
          })(),
        },
        {
          name: "This Month",
          date_val: (() => {
            const startOfMonth = new Date();
            startOfMonth.setDate(1);
            const endOfMonth = new Date(startOfMonth);
            endOfMonth.setMonth(endOfMonth.getMonth() + 1);
            endOfMonth.setDate(endOfMonth.getDate() - 1);
            return `${startOfMonth.toLocaleDateString()} to ${endOfMonth.toLocaleDateString()}`;
          })(),
        },
        {
          name: "Last Month",
          date_val: (() => {
            const today = new Date();
            const startOfLastMonth = new Date(
              today.getFullYear(),
              today.getMonth() - 1,
              1
            );
            const endOfLastMonth = new Date(
              today.getFullYear(),
              today.getMonth(),
              0
            );
            return `${startOfLastMonth.toLocaleDateString()} to ${endOfLastMonth.toLocaleDateString()}`;
          })(),
        },

        { name: "Custom Date (From To)", date_val: "customDate" },
      ],
      dateValue: "",

      customDate: {
        from: "",
        to: "",
      },
      fromDate: "",
      toDate: "",

      showCustomInputs: false,

      isLoader: true,
      org_ids: "",
      admin_user: "",
      log_type: "",
      log_action: "",
      search: "",
      selectedType: "",
      logType: "",
      actionType: "",
      org_search: "",
      org_search_value: "all",
      organizations: [],
      awaitingSearch: false,
      excelDownloadData: [],
      json_fields: {
        "organization name": "organization_name",
        Name: "first_name",
        "User name": "user_name",
        Email: "user_name_cus",
        Role: {
          field: "role_id",
          callback: (value) => {
            if (value == 10) {
              return `Customer`;
            } else if (value == 6) {
              return `Driver`;
            } else if (value == 3) {
              return `Manager`;
            } else if (value == 9) {
              return `Production Supervisor`;
            } else if (value == 4) {
              return `Shipping and Receiving`;
            } else if (value == 0) {
              return `Admin`;
            }
          },
        },
        Status: {
          field: "send_update_email",
          callback: (value) => {
            if (value == 1) {
              return `Subscribed`;
            } else {
              return `Not Subscribed`;
            }
          },
        },
      },
      type_filter: [
        { name: "Admin", id: "1" },
        { name: "CRM", id: "2" },
        { name: "Editor", id: "3" },
        { name: "Support", id: "4" },
        { name: "Data Entry", id: "5" },
        { name: "Digital Marketing", id: "6" },
        { name: "CSM", id: "10" },
      ],
      type_logs: [
        { name: "Pickup Cart", log_type: "0" },
        { name: "Incoming Cart", log_type: "1" },
        { name: "Outgoing Cart", log_type: "2" },
        { name: "Pickup Manifest", log_type: "3" },
        { name: "Receiving Manifest", log_type: "4" },
        { name: "Shipping Manifest", log_type: "5" },
        { name: "Invoice", log_type: "6" },
        { name: "Order", log_type: "7" },
        { name: "Invoice Statement", log_type: "8" },
        { name: "Customer", log_type: "9" },
        { name: "Login", log_type: "10" },
        { name: "User Note", log_type: "11" },
        { name: "Missing Items", log_type: "12" },
        { name: "CPI", log_type: "13" },
        { name: "Support Ticket", log_type: "14" },
        { name: "Rewash Cart", log_type: "15" },
        { name: "PPOH", log_type: "16" },
        { name: "Carts Picked up", log_type: "17" },
        { name: "User", log_type: "18" },
        { name: "Customer Scheduler", log_type: "19" },
        { name: "Stained Cart", log_type: "20" },
        { name: "Group Invoice", log_type: "21" },
        { name: "Logout", log_type: "22" },
        { name: "LoginFromAdmin", log_type: "23" },
        { name: "RFID Customer Mismatch Item", log_type: "24" },
        { name: "Data Sync", log_type: "25" },
      ],
      type_actions: [
        { name: "Created", log_action: "0" },
        { name: "Updated", log_action: "1" },
        { name: "Deleted", log_action: "2" },
        { name: "Delivered", log_action: "3" },
        { name: "Load", log_action: "4" },
        { name: "Signature", log_action: "5" },
        { name: "Email", log_action: "6" },
        { name: "Price Updated", log_action: "7" },
        { name: "Price Changed", log_action: "8" },
        { name: "Changing Soon", log_action: "9" },
        { name: "New Message", log_action: "10" },
        { name: "Price Changed Reason", log_action: "11" },
        { name: "Email Error", log_action: "12" },
        { name: "Ignored Alert", log_action: "13" },
        { name: "Soft Deleted", log_action: "14" },
        { name: "Restored", log_action: "15" },
        { name: "Ignored Weight Variation Alert", log_action: "16" },
        { name: "Ignored Max Net Weight Alert", log_action: "17" },
        { name: "Email Bounce", log_action: "18" },
        { name: "Email Spam", log_action: "19" },
        { name: "Login", log_action: "20" },
        { name: "Logout", log_action: "21" },
        { name: "Receiving Manifest to Order", log_action: "22" },
        { name: "Customer Missing", log_action: "23" },
        { name: "Item Missing", log_action: "24" },
        { name: "Customer Item Missing", log_action: "25" },
        { name: "Customer Department Missing", log_action: "26" },
        { name: "Customer Department Item Missing", log_action: "27" },
      ],
    };
  },

    props: ["users", "totalPages", "page", "organization_search","setSkeletonLoader"],

  computed: {
    currentPage: {
      get: function () {
        return this.page;
      },
        set: function () { },
    },
    filteredList() {
      return this.users;
    },
      showskLoader:function(){
      // console.log("showskLoader",this.setskeletonLoader);
      this.isLoader = this.setskeletonLoader;
      return this.setskeletonLoader;
      }
    },
    watch:{
    showskLoader: function () {
      this.isLoader = this.setskeletonLoader;
      return this.setskeletonLoader;
      }
     } ,
  async created() {
    // let loader = this.$loading.show({
    //       loader: 'dots',
    //       container: this.fullPage ? null : this.$refs.formContainer,
    //   });
    this.isLoader = true;
    const permission = {
      headers: {
        'X-Permission': 'all_organization_list' 
      }
    };
      await axios.get("/admin/users/get-all-organizations",permission).then((response) => {
        this.organizations = response.data;
        this.organizations.unshift({
          name: "All Organizations",
          organization_id: "",
        })

        // loader.hide();
      }).then(()=>{
        // this.isLoader = false;
      });

    this.getExcelOrgUsers();
    // setTimeout(() => loader.hide(), 1 * 5000)
  },

  methods: {
    fetchAdminLogs(page=1) {
      this.isLoader = true;
      page = page== 1 ? page : this.page
      axios
        .get(
          `/admin/users/test?page=${page}&organization=${this.org_ids}&admin_user=${this.admin_user}&log_type=${this.log_type}&log_action=${this.log_action}&search=${this.search}&from=${this.fromDate}&to=${this.toDate}`
        )
        .then((response) => {
          this.users = response.data.data;
          this.totalPages = Math.ceil(response.data.total / 100);
          this.isLoader = false;
          console.log(response);
        })
        .catch((error) => {
          // Handle error if needed
          this.isLoader = false;
        });
    },
    applyDateFilter() {
      if (this.dateValue.date_val === "customDate") {
        this.fromDate = this.customDate.from;
        this.toDate = this.customDate.to;
        this.showCustomInputs = true;
        if (this.fromDate && this.toDate) {
          this.fetchAdminLogs();
        }
      } else {
        if (this.dateValue.date_val === "no_date") {
          this.fromDate = "";
          this.toDate = "";
          this.fetchAdminLogs();
        }
        const dates = this.dateValue.date_val.split(" to ");
        this.fromDate = new Date(dates[0]).toISOString().split("T")[0];
        this.toDate = new Date(dates[1]).toISOString().split("T")[0];
        this.customDate.from = "";
        this.customDate.to = "";
        this.showCustomInputs = false;
        this.fetchAdminLogs();
      }
    },
    getExcelOrgUsers() {
      axios
        .get("/admin/users?limit=" + 0 + "&role_id=" + this.selectedType)
        .then((response) => {
          let res = response.data;
          this.excelDownloadData = res.data;
          setTimeout(() => {
            this.isLoader = false;
              },1500);
                
        });
    },
    setPage(page) {
      this.$emit("setPage", page, this.org_search_value);
    },
    clear() {
      this.results = "";
      this.search = "";
    },

    handleSearch: _.debounce(function () {
      this.preApiCall();
    }, 500),

    preApiCall() {
      if (cancel != undefined) {
        cancel();
      }
      this.apiCall(this.search);
    },
    apiCall(query) {
      // let loader = this.$loading.show({
      //   loader: "dots",
      //   container: this.fullPage ? null : this.$refs.formContainer,
      // });
      this.isLoader = true;
      let self = this;
      let subsribed_user = "";
      this.$store
        .dispatch("users/getAllUsers", [self.page, self.search, subsribed_user])
        .then(() => {
          // loader.hide();
          this.isLoader = false;
        });
    },
    subscribeUsers() {
      // let loader = this.$loading.show({
      //   loader: "dots",
      //   container: this.fullPage ? null : this.$refs.formContainer,
      // });
      this.isLoader = true;
      let self = this;
      var subsribed_user = $("#subscribed-users").prop("checked");
      if (subsribed_user == true) {
        this.$store
          .dispatch("users/getAllUsers", [
            self.page,
            self.search,
            subsribed_user,
          ])
          .then(() => {
            // loader.hide();
            this.isLoader = false;
          });
      } else {
        this.organizationSearch();
        // loader.hide();
        this.isLoader = false;
      }
      // setTimeout(() => loader.hide(), 1 * 1000)
    },
    organizationSearch() {
      // let loader = this.$loading.show({
      //   loader: "dots",
      //   container: this.fullPage ? null : this.$refs.formContainer,
      // });
      this.isLoader = true;
      let self = this;
      // this.org_search_value =
      //   this.org_search != undefined
      //     ? this.org_search.organization_id
      //     : "";
      this.org_ids =
        this.org_search != undefined
          ? this.org_search.map(({ organization_id }) => organization_id)
          : "";
          // console.log(this.org_search.map(({ organization_id }) => organization_id))
      this.fetchAdminLogs(1);
    },

    usersBySearch() {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          // let loader = this.$loading.show({
          //   loader: "dots",
          //   container: this.fullPage ? null : this.$refs.formContainer,
          // });
          this.fetchAdminLogs(1);

          this.awaitingSearch = false;
        }, 800);
      }
      this.awaitingSearch = true;
    },
    filterByAdminUser() {
      // this.admin_user = this.selectedType.id;
      this.admin_user = this.selectedType.map(option => option.id);
      this.fetchAdminLogs(1);
    },
    filterByLogType(event) {
      this.log_type = this.logType.map(option => option.log_type);
      this.fetchAdminLogs(1);
    },
    filterByLogActionType(event) {
      this.log_action = this.actionType.map(option => option.log_action);
      this.fetchAdminLogs(1);
    },
    create_user(user_id) {
      this.$store.dispatch("modal/update", {
        action: "create",
        title: user_id == undefined ? "Add User" : "Update User",
        formData: user_id,
        component: UserForm,
      });
    },
  },
};
</script>
<style scoped>
.has-search .form-control {
  height: calc(1.4em + 0.75rem + 2px) !important;
}
</style>
